import React, { Component } from 'react';
import { Button } from 'rsuite';
import {newsleterAccept} from '../serviceWorkerRegistration';


export default class Home extends Component {
  constructor() {
      super();
      this.state = {
          name: ''
      }
      this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
  }

  handleSubmit(e) {
      e.preventDefault();
      newsleterAccept();
  }





    render() {
        return (
            <div>
            <Button appearance="primary" type="submit" onClick={this.handleSubmit} className="btn btn-primary iron-button">
                Notify
            </Button>
                Home Component
            </div>
        );
    }
}
